import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ScheduledCustomSurvey } from '../../domain/custom-survey/scheduled-survey-presenter';
import { put } from '../../utils/networking';

const updateScheduledCustomSurvey = async (
  teamId: number,
  surveyId: number,
  survey: Partial<ScheduledCustomSurvey> & {
    templateId: number;
    deadlineInDays: number;
    minimumResponseRate: number;
    allowAnonymous: boolean;
    isActive: boolean;
    description?: string | null;
  },
) => {
  // Ensure scheduledTime is sent as ISO string if it's a Date object
  const scheduledTime = survey.scheduledTime instanceof Date
    ? survey.scheduledTime.toISOString()
    : survey.scheduledTime;

  return put(`/api/schedule-custom-surveys/${teamId}/${surveyId}`, {
    title: survey.title,
    description: survey.description,
    templateId: survey.templateId,
    scheduledTime,
    frequency: survey.frequency,
    deadlineInDays: survey.deadlineInDays,
    minimumResponseRate: survey.minimumResponseRate,
    allowAnonymous: survey.allowAnonymous,
    isActive: survey.isActive,
  });
};

export const useUpdateScheduledCustomSurveyMutation = (teamId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      teamId,
      surveyId,
      survey,
    }: {
      teamId: number;
      surveyId: number;
      survey: Partial<ScheduledCustomSurvey> & {
        templateId: number;
        deadlineInDays: number;
        minimumResponseRate: number;
        allowAnonymous: boolean;
        isActive: boolean;
    description?: string | null;
      };
    }) => updateScheduledCustomSurvey(teamId, surveyId, survey),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['scheduledCustomSurveys', teamId],
      });
      queryClient.invalidateQueries({
        queryKey: ['scheduledCustomSurvey', teamId],
      });
    },
  });
};
